import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import API from "../Context/api";
import EditLocalPurchaseOrderForm from "./EditLocalPurchaseOrderForm";
import AddLocalPurchaseOrderForm from "./AddLocalPurchaseOrderForm";
import { useAuth } from "../Context/AuthContext";

function LocalPurchaseOrders() {
  const [lpos, setLpos] = useState([]);
  const [lpoToDelete, setLpoToDelete] = useState(null);
  const [lpoToEdit, setLpoToEdit] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenEdit, setModalOpenEdit] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false); // State for deleting status

  const navigate = useNavigate();

  const { user } = useAuth();
  const isAdmin = user?.role === "Admin";

  const fetchLpos = async () => {
    try {
      const response = await API.get("/localpurchaseorders");
      setLpos(response.data);
      console.log(response.data);
      setLoading(false);
    } catch (error) {
      setError("Failed to fetch LPOs");
      setLoading(false);
      console.error("Error fetching LPOs:", error);
    }
  };

  useEffect(() => {
    fetchLpos();
  }, []);

  const handleDeleteClick = (id) => {
    setLpoToDelete(id);
    setModalOpen(true);
  };

  if (loading) {
    return (
      <div className="flex items-center justify-center h-full">
        <div className="text-gray-500 text-lg animate-pulse">Loading...</div>
      </div>
    );
  }

  if (error)
    return <div className="text-center text-red-500 py-10">{error}</div>;

  const closeModal = () => {
    setModalOpen(false);
    setLpoToDelete(null);
    setIsDeleting(false); // Reset deleting state
  };

  const handleDeleteLpo = async () => {
    if (lpoToDelete) {
      setIsDeleting(true); // Set deleting state to true
      try {
        await API.delete(`/localpurchaseorders/${lpoToDelete}`);
        fetchLpos(); // Refresh the list immediately after deletion
      } catch (error) {
        console.error("Error deleting LPO:", error);
        alert("Failed to delete LPO.");
      } finally {
        closeModal();
      }
    }
  };

  const handleEditLpo = (id) => {
    setLpoToEdit(id);
    setModalOpenEdit(true);
  };

  const handleViewLpo = (id) => {
    navigate(`/lpo/${id}`);
  };

  const handleSearchChange = (e) => {
    setSearchQuery(e.target.value);
  };

  const filteredLpos = lpos.filter((lpo) =>
    (lpo.lpoDetails?.client || "")
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  const handleAddLpo = () => {
    setIsModalOpen(true);
  };

  const handleLpoUpdated = () => {
    fetchLpos();
    setIsModalOpen(false);
    setModalOpenEdit(false);
  };

  return (
    // <div className="p-4 bg-gray-50 min-h-full flex flex-col">
    //   {/* Sticky Search Bar */}
    //   <div className="bg-white rounded-lg shadow-sm p-4 sticky top-0 z-10">
    //     <div className="flex flex-col sm:flex-row justify-between items-center gap-4">
    //       <input
    //         type="text"
    //         placeholder="Search by customer..."
    //         value={searchQuery}
    //         onChange={handleSearchChange}
    //         className="w-full sm:w-72 p-3 border border-gray-300 rounded-lg shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all duration-200"
    //       />
    //       <button
    //         onClick={handleAddLpo}
    //         className="w-full sm:w-auto bg-blue-600 text-white px-6 py-2 rounded-lg shadow-md hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-opacity-50 transition-all duration-200"
    //       >
    //         Add LPO
    //       </button>
    //     </div>
    //   </div>

    //   {/* Table for Medium and Larger Screens */}
    //   <div className="flex-1 overflow-y-auto mt-4">
    //     {/* Table for Larger Screens */}
    //     {/* Table for Larger Screens */}
    //     <div className="hidden sm:block bg-white rounded-lg shadow-sm">
    //       <table className="w-full text-left table-fixed">
    //         <thead className="bg-gray-100 sticky top-0 z-10">
    //           <tr>
    //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //               LPO No
    //             </th>
    //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //               Customer
    //             </th>
    //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //               Date
    //             </th>
    //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //               Grand Total (USD)
    //             </th>
    //             <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
    //               Actions
    //             </th>
    //           </tr>
    //         </thead>
    //         <tbody className="bg-white divide-y divide-gray-200">
    //           {filteredLpos.map((lpo) => (
    //             <tr
    //               key={lpo.id} // Changed from _id to id
    //               className="hover:bg-gray-50 transition-colors duration-150"
    //             >
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {lpo.lpoDetails.lpoNo}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {lpo.lpoDetails.client}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {new Date(lpo.lpoDetails.date).toLocaleDateString()}
    //               </td>
    //               <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
    //                 {lpo.lpoDetails.grandTotal.toLocaleString()}
    //               </td>
    //               <td className="px-4 py-3 flex gap-2 flex-col justify-start items-start flex-wrap">
    //                 <button
    //                   onClick={() => handleViewLpo(lpo.id)} // Changed to id
    //                   className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //                 >
    //                   View
    //                 </button>
    //                 <button
    //                   onClick={() => handleEditLpo(lpo.id)} // Changed to id
    //                   className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //                 >
    //                   Edit
    //                 </button>

    //                 {isAdmin && (
    //                   <>
    //                     <button
    //                       onClick={() => handleDeleteClick(lpo.id)} // Changed to id
    //                       className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //                     >
    //                       Delete
    //                     </button>
    //                   </>
    //                 )}
    //               </td>
    //             </tr>
    //           ))}
    //         </tbody>
    //       </table>
    //     </div>
    //   </div>

    //   {/* Cards for Small Screens */}
    //   <div className="md:hidden space-y-4">
    //     {filteredLpos.map((lpo) => (
    //       <div key={lpo.id} className="bg-white p-4 rounded-lg shadow-md">
    //         <h3 className="text-lg font-semibold text-gray-900 truncate">
    //           {lpo.lpoDetails.lpoNo}
    //         </h3>
    //         <p className="text-sm text-gray-600 mt-1">
    //           {lpo.lpoDetails.client}
    //         </p>
    //         <p className="text-sm text-gray-500">
    //           Date: {new Date(lpo.lpoDetails.date).toLocaleDateString()}
    //         </p>
    //         <p className="text-sm text-gray-500">
    //           Grand Total: USD {lpo.lpoDetails.grandTotal.toLocaleString()}
    //         </p>
    //         <div className="mt-3 flex flex-wrap gap-2">
    //           <button
    //             onClick={() => handleViewLpo(lpo.id)} // Changed to id
    //             className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             View
    //           </button>
    //           <button
    //             onClick={() => handleEditLpo(lpo.id)} // Changed to id
    //             className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             Edit
    //           </button>
    //           {isAdmin && (
    //             <>
    //               <button
    //                 onClick={() => handleDeleteClick(lpo.id)} // Changed to id
    //                 className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //               >
    //                 Delete
    //               </button>
    //             </>
    //           )}
    //         </div>
    //       </div>
    //     ))}
    //   </div>

    //   {/* Delete Confirmation Modal */}
    //   {modalOpen && (
    //     <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 px-4">
    //       <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
    //         <h2 className="text-xl font-bold text-gray-900">
    //           Confirm Deletion
    //         </h2>
    //         <p className="text-gray-600 mt-2">
    //           Are you sure you want to delete this LPO?
    //         </p>
    //         <div className="mt-6 flex justify-end gap-3">
    //           <button
    //             onClick={closeModal}
    //             className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             Cancel
    //           </button>
    //           <button
    //             onClick={handleDeleteLpo}
    //             disabled={isDeleting}
    //             className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
    //           >
    //             {isDeleting ? "Deleting..." : "Delete"}
    //           </button>
    //         </div>
    //       </div>
    //     </div>
    //   )}

    //   {/* Add LPO Modal */}
    //   {isModalOpen && (
    //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 z-50">
    //     //   <div className="w-full max-w-4xl h-[90vh] bg-white p-6 rounded-lg shadow-xl overflow-y-auto">
    //     //     <AddLocalPurchaseOrderForm
    //     //       setIsModalOpen={setIsModalOpen}
    //     //       onLpoUpdated={handleLpoUpdated}
    //     //     />
    //     //   </div>
    //     // </div>
    //     <AddLocalPurchaseOrderForm
    //       setIsModalOpen={setIsModalOpen}
    //       onLpoUpdated={handleLpoUpdated}
    //     />
    //   )}

    //   {/* Edit LPO Modal */}
    //   {modalOpenEdit && (
    //     // <div className="fixed inset-0 flex items-center justify-center bg-gray-900 bg-opacity-60 z-50">
    //     //   <div className="w-full max-w-4xl h-[90vh] bg-white p-6 rounded-lg shadow-xl overflow-y-auto">
    //     //     <EditLocalPurchaseOrderForm
    //     //       id={lpoToEdit}
    //     //       setIsModalOpen={setModalOpenEdit}
    //     //       onLpoUpdated={handleLpoUpdated}
    //     //     />
    //     //   </div>
    //     // </div>
    //     <EditLocalPurchaseOrderForm
    //       id={lpoToEdit}
    //       setIsModalOpen={setModalOpenEdit}
    //       onLpoUpdated={handleLpoUpdated}
    //     />
    //   )}
    // </div>

    <div className="h-full flex flex-col">
      {/* Static Header */}
      <h3 className="text-xl font-semibold mb-2 text-gray-900">
        Local Purchase Order
      </h3>

      <div className="py-2 mb-4 flex items-center justify-between gap-4 flex-wrap">
        <input
          type="text"
          placeholder="Search by customer..."
          value={searchQuery}
          onChange={handleSearchChange}
          className="p-2 border rounded w-full md:w-64 focus:ring-2 focus:ring-indigo-500 focus:outline-none"
        />
        <button
          onClick={handleAddLpo}
          className="px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto"
        >
          Add LPO
        </button>
      </div>

      {/* Scrollable Content */}
      <div className="flex-1 overflow-y-auto space-y-3">
        {/* <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  LPO No
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Customer
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Date
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Grand Total (USD)
                </th>
                <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredLpos.map((lpo, index) => (
                <tr
                  key={lpo.id}
                  className={`text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-colors duration-150`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {lpo.lpoDetails.lpoNo}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {lpo.lpoDetails.client}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {new Date(lpo.lpoDetails.date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {lpo.lpoDetails.grandTotal.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 flex gap-2 flex-col justify-start items-start flex-wrap">
                    <button
                      onClick={() => handleViewLpo(lpo.id)}
                      className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      View
                    </button>
                    <button
                      onClick={() => handleEditLpo(lpo.id)}
                      className="bg-blue-500 text-white w-20 px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Edit
                    </button>

                    {isAdmin && (
                      <button
                        onClick={() => handleDeleteClick(lpo.id)}
                        className="bg-red-500 text-white w-20 px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div> */}
        {/* Desktop Table */}
        <div className="hidden sm:block bg-white rounded-lg shadow-sm">
          <table className="w-full text-left table-fixed">
            <thead className="bg-gray-100 sticky top-0 z-10">
              <tr>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  LPO No
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Customer
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Date
                </th>
                <th className="w-[12%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Grand Total (USD)
                </th>
                <th className="w-[15%] px-4 py-3 text-sm font-semibold text-gray-600 uppercase tracking-wider">
                  Actions
                </th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-300">
              {filteredLpos.map((lpo, index) => (
                <tr
                  key={lpo.id}
                  className={`text-sm ${
                    index % 2 === 0 ? "bg-white" : "bg-gray-50"
                  } hover:bg-gray-100 transition-colors duration-150`}
                >
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    <span
                      onClick={() => handleViewLpo(lpo.id)}
                      className="hover:underline cursor-pointer"
                    >
                      {lpo.lpoDetails.lpoNo}
                    </span>
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {lpo.lpoDetails.client}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {new Date(lpo.lpoDetails.date).toLocaleDateString()}
                  </td>
                  <td className="px-4 py-3 text-gray-700 text-sm whitespace-normal break-words align-top">
                    {lpo.lpoDetails.grandTotal.toLocaleString()}
                  </td>
                  <td className="px-4 py-3 flex gap-2 flex-row justify-start items-center flex-wrap">
                    <button
                      onClick={() => handleEditLpo(lpo.id)}
                      className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Edit
                    </button>
                    {isAdmin && (
                      <button
                        onClick={() => handleDeleteClick(lpo.id)}
                        className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                      >
                        Delete
                      </button>
                    )}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {/* Cards for Small Screens */}
        {/* <div className="md:hidden space-y-4">
          {filteredLpos.map((lpo) => (
            <div key={lpo.id} className="bg-white p-4 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold text-gray-900 truncate">
                {lpo.lpoDetails.lpoNo}
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {lpo.lpoDetails.client}
              </p>
              <p className="text-sm text-gray-500">
                Date: {new Date(lpo.lpoDetails.date).toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-500">
                Grand Total: USD {lpo.lpoDetails.grandTotal.toLocaleString()}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <button
                  onClick={() => handleViewLpo(lpo.id)} // Changed to id
                  className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                >
                  View
                </button>
                <button
                  onClick={() => handleEditLpo(lpo.id)} // Changed to id
                  className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                >
                  Edit
                </button>
                {isAdmin && (
                  <>
                    <button
                      onClick={() => handleDeleteClick(lpo.id)} // Changed to id
                      className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                    >
                      Delete
                    </button>
                  </>
                )}
              </div>
            </div>
          ))}
        </div> */}
        {/* Mobile Cards */}
        <div className="md:hidden space-y-4">
          {filteredLpos.map((lpo) => (
            <div key={lpo.id} className="bg-white p-4 rounded-lg shadow-md">
              <h3 className="text-lg font-semibold truncate hover:underline cursor-pointer">
                <span onClick={() => handleViewLpo(lpo.id)}>
                  {lpo.lpoDetails.lpoNo}
                </span>
              </h3>
              <p className="text-sm text-gray-600 mt-1">
                {lpo.lpoDetails.client}
              </p>
              <p className="text-sm text-gray-500">
                Date: {new Date(lpo.lpoDetails.date).toLocaleDateString()}
              </p>
              <p className="text-sm text-gray-500">
                Grand Total: USD {lpo.lpoDetails.grandTotal.toLocaleString()}
              </p>
              <div className="mt-3 flex flex-wrap gap-2">
                <button
                  onClick={() => handleEditLpo(lpo.id)}
                  className="bg-blue-500 text-white px-3 py-1 rounded-md hover:bg-blue-600 focus:outline-none focus:ring-2 focus:ring-blue-400 focus:ring-opacity-50 transition-all duration-200"
                >
                  Edit
                </button>
                {isAdmin && (
                  <button
                    onClick={() => handleDeleteClick(lpo.id)}
                    className="bg-red-500 text-white px-3 py-1 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                  >
                    Delete
                  </button>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Delete Confirmation Modal */}
      {modalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-60 z-50 px-4">
          <div className="bg-white p-6 rounded-lg shadow-xl w-full max-w-md">
            <h2 className="text-xl font-bold text-gray-900">
              Confirm Deletion
            </h2>
            <p className="text-gray-600 mt-2">
              Are you sure you want to delete this LPO?
            </p>
            <div className="mt-6 flex justify-end gap-3">
              <button
                onClick={closeModal}
                className="bg-gray-500 text-white px-4 py-2 rounded-md hover:bg-gray-600 focus:outline-none focus:ring-2 focus:ring-gray-400 focus:ring-opacity-50 transition-all duration-200"
              >
                Cancel
              </button>
              <button
                onClick={handleDeleteLpo}
                disabled={isDeleting}
                // className="bg-red-500 text-white px-4 py-2 rounded-md hover:bg-red-600 focus:outline-none focus:ring-2 focus:ring-red-400 focus:ring-opacity-50 transition-all duration-200"
                className={`px-4 py-2 rounded-md text-sm font-medium transition-all duration-200 shadow-sm w-full sm:w-auto ${
                  isDeleting
                    ? "bg-gray-300 text-gray-600 cursor-not-allowed"
                    : "bg-red-500 text-white hover:bg-red-600"
                }`}
              >
                {isDeleting ? "Deleting..." : "Delete"}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Add LPO Modal */}
      {isModalOpen && (
        <AddLocalPurchaseOrderForm
          setIsModalOpen={setIsModalOpen}
          onLpoUpdated={handleLpoUpdated}
        />
      )}

      {/* Edit LPO Modal */}
      {modalOpenEdit && (
        <EditLocalPurchaseOrderForm
          id={lpoToEdit}
          setIsModalOpen={setModalOpenEdit}
          onLpoUpdated={handleLpoUpdated}
        />
      )}
    </div>
  );
}

export default LocalPurchaseOrders;
